import { faCheck, faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineXS, LabelM } from '@sorare/core/src/atoms/typography';
import { OverlapItems } from '@sorare/core/src/atoms/ui/OverlapItems';
import { StatIcon } from '@sorare/core/src/components/stats/StatIcon';

import { CELEBRATION_2024_BLOG_POST_URL } from 'lib/events';

const StyledOverlapItems = styled(OverlapItems)`
  & > * {
    outline: 2px solid var(--c-black);
    border-radius: 50%;
  }
`;

const Metas = styled(Vertical)`
  align-items: flex-start;
`;

const Title = styled(HeadlineXS)`
  display: flex;
  align-items: baseline;
  gap: var(--half-unit);
`;

export const CelebrationDisclaimer = () => {
  return (
    <Vertical>
      <Title color="var(--c-nd-600)">
        <FormattedMessage
          id="CelebrationDisclaimer.title"
          defaultMessage="Celebration Edition"
        />
        <IconButton
          color="transparent"
          small
          icon={faInfoCircle}
          to={CELEBRATION_2024_BLOG_POST_URL}
        />
      </Title>
      <Metas>
        <Horizontal>
          <Button
            color="tertiary"
            size="small"
            to={CELEBRATION_2024_BLOG_POST_URL}
          >
            <StyledOverlapItems>
              <StatIcon statKey="last_man_tackle" />
              <StatIcon statKey="assist_penalty_won" />
              <StatIcon statKey="clean_sheet_60" />
              <StatIcon statKey="penalty_save" />
              <StatIcon statKey="goal_assist" />
              <StatIcon statKey="goals" />
            </StyledOverlapItems>
            <LabelM bold>
              <FormattedMessage
                id="CelebrationDisclaimer.explanation"
                defaultMessage="Reveal player after they make a decisive action"
              />
            </LabelM>
          </Button>
          <Button
            color="tertiary"
            size="small"
            to={CELEBRATION_2024_BLOG_POST_URL}
          >
            <FontAwesomeIcon icon={faCheck} />
            <LabelM bold>
              <FormattedMessage
                id="EarlyAccessMetas.playableNow"
                defaultMessage="Playable now"
              />
            </LabelM>
          </Button>
        </Horizontal>
      </Metas>
    </Vertical>
  );
};
